import React from 'react';
import { getPageLogoUrl, intl } from 'ehs-react';

export const AccessPageLogo = () => {
  return (
    <img
      src={getPageLogoUrl()}
      className="logo-image"
      alt={intl(
        'patientSelfOnboardingPortlet.welcomeScreen.logoAltTextHealthineers'
      )}
    />
  );
};
